import axios, { AxiosResponse } from 'axios';
import { Mode } from '@thirdweb-dev/chains';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { StrategyDetails } from '@app/types/plugins';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';
import { useChainId } from '@thirdweb-dev/react';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';

type SmartPoolsResponse = {
  pools: Record<string, StrategyDetails[]>;
};

async function fetcher(
  config: ApplicationConfig | undefined,
  chainId: number | undefined
) {
  if (!chainId) {
    return null;
  }

  const { data } = await axios.get<void, AxiosResponse<SmartPoolsResponse>>(
    `${config?.URLS.steerApiUrl}/getSmartPools?chainId=${chainId}&dexName=kim`
  );

  return data;
}

export function useSmartPools() {
  const config = useConfig();
  const chainId = useSupportedChain()?.chainId;

  return useQuery(
    [QueryKeys.SMART_POOLS, chainId],
    () => {
      return fetcher(config, chainId);
    },
    {
      enabled: !!chainId
    }
  );
}
